import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import {useStores} from "~/stores";
import {DISPLAY_URL} from "../services/categoryProfileUrls";

/** What customers see of the Category Profile (staff settings, Display group). */
export type CategoryProfileDisplay = {
    showDashboardCard: boolean;
    hiddenTabs: string[];
    /** Mithra staff keep seeing hidden parts, marked as hidden. */
    seesHidden: boolean;
};

/** The Display settings; any signed-in user reads them. Only asked for when the customer has the Category Profile. */
export function useCategoryProfileDisplay(enabled = true) {
    return useCustomQuery({
        queryKey: [DISPLAY_URL] as const,
        queryFn: async () => (await queryHttp.get<CategoryProfileDisplay>(DISPLAY_URL)).data,
        enabled,
        retry: false,
        staleTime: 5 * 60 * 1000,
    });
}

/**
 * Whether the Category Profile card (dashboard, menu, Spend Landscape bar) shows: the customer configuration makes it
 * available (`showCards`), the Display settings show it to customers. Staff always see it. Hidden until the settings
 * are loaded, so a hidden card does not flash; shown if they cannot be loaded.
 */
export function useCategoryProfileCardVisible(): boolean {
    const {p, authStore} = useStores();
    const available = p.showCard('category-explore', authStore);
    const display = useCategoryProfileDisplay(available);
    if (!available) return false;
    if (display.isError) return true;
    return Boolean(display.data && (display.data.showDashboardCard || display.data.seesHidden));
}
